var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPatient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_22334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2004 14.2691C19.0535 14.2691 22.177 11.1654 22.177 7.33692C22.177 3.50841 19.0535 0.404785 15.2004 0.404785C11.3474 0.404785 8.22388 3.50841 8.22388 7.33692C8.22388 11.1654 11.3474 14.2691 15.2004 14.2691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.800537 29.3116C0.800537 21.4063 7.24441 15.0034 15.2005 15.0034C23.1565 15.0034 29.6004 21.4063 29.6004 29.3116H0.800537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8982 23.5064H16.5578V24.8381C16.5578 25.6406 16.0251 26.1699 15.2175 26.1699C14.4099 26.1699 13.8772 25.6406 13.8772 24.8381V23.5064H12.5369C11.7292 23.5064 11.1965 22.9771 11.1965 22.1746C11.1965 21.3721 11.7292 20.8428 12.5369 20.8428H13.8772V19.511C13.8772 18.7085 14.4099 18.1792 15.2175 18.1792C16.0251 18.1792 16.5578 18.7085 16.5578 19.511V20.8428H17.8982C18.7058 20.8428 19.2385 21.3721 19.2385 22.1746C19.2385 22.96 18.7058 23.5064 17.8982 23.5064Z",
    fill: "#D5D5D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_22334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7998,
    height: 28.9067,
    fill: "white",
    transform: "translate(0.800537 0.404785)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatient);
export default __webpack_public_path__ + "static/media/icon-patient.d452c10e0c5c5427ff9b651390bf30c2.svg";
export { ForwardRef as ReactComponent };